<template>
<el-dialog title="订单详情" :visible.sync="dialogVisible" width="800px" @close="handleClose" class="order-details-dialog" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-scrollbar class="order-details-dialog-scroll" v-loading="contentLoading">
        <div class="module-name">用户信息</div>
        <div class="info-item">
            <div class="label">用户名称：</div>
            <div class="value">{{details.customername}}({{details.customerinnerid}})</div>
        </div>
        <div class="info-item">
            <div class="label">手机号码：</div>
            <div class="value">{{details.mobileno}}</div>
        </div>
        <div class="module-name" style="margin-top: 20px">订单信息</div>
        <div class="info-item">
            <div class="label">订单号：</div>
            <div class="value">{{details.orderno}}</div>
        </div>
        <div class="info-item">
            <div class="label">订单来源：</div>
            <div class="value">{{details.ordersourcename}}</div>
        </div>
        <div class="info-item">
            <div class="label">订单类型：</div>
            <div class="value">{{details.ordertypename}}</div>
        </div>
        <div class="info-item">
            <div class="label">产品名称：</div>
            <div class="value">{{details.productname}}</div>
        </div>
        <div class="info-item">
            <div class="label">付款方式：</div>
            <div class="value">{{details.paytypename}}</div>
        </div>
        <div class="info-item">
            <div class="label">支付金额：</div>
            <div class="value">{{details.finalpaymoney ? (details.finalpaymoney + '元') : '--'}}</div>
        </div>
        <div class="info-item">
            <div class="label">订单时间：</div>
            <div class="value">{{details.orderdatetime}}</div>
        </div>
        <div class="info-item">
            <div class="label">订单状态：</div>
            <div class="value">{{details.orderstatusname}}</div>
        </div>
    </el-scrollbar>
</el-dialog>
</template>

<script>
import {getTopicQuestionbankOrderDetail} from 'api/questionApi'
export default {
    name: 'orderDetailsDialog',
    data() {
        return {
            dialogVisible: false,
            orderno: '',
            contentLoading: false,
            details: {}
        }
    },
    mounted() {
    },
    methods: {
        handleOpen(row) {
            this.dialogVisible = true
            this.orderno = row.orderno
            this.handleGetTopicQuestionbankOrderDetail(this.orderno)
        },
        handleClose() {
            this.dialogVisible = false
            this.orderno = ''
            this.details = {}
        },
        handleGetTopicQuestionbankOrderDetail(orderno) {
            this.contentLoading = true
            getTopicQuestionbankOrderDetail({
                data: {
                    code: orderno,
                    apptype: 0
                },
                success: data => {
                    this.details = data.data
                    this.contentLoading = false
                },
                error: data => {
                    this.contentLoading = false
                    this.$message.error(data.msg)
                }
            })
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.order-details-dialog {
    .el-dialog {
        height: 455px;
        .el-dialog__body {
            height: 400px;
            box-sizing: border-box;
            padding: 0;
            .order-details-dialog-scroll {
                height: 100%;
                .el-scrollbar__view {
                    padding: 20px !important;
                    box-sizing: border-box;
                    .module-name {
                        font-size: 16px;
                        color: #333333;
                        font-weight: bold;
                        display: flex;
                        align-items: center;
                        margin-bottom: 15px;
                        &::before {
                            content: '';
                            width: 4px;
                            height: 20px;
                            background: #409EFF;
                            margin-right: 5px;
                        }
                    }
                    .info-item {
                        display: flex;
                        margin-bottom: 10px;
                        line-height: 18px;
                        .label {
                            width: 70px;
                            color: #666666;
                            font-size: 14px;
                        }
                        .value {
                            flex: 1;
                            width: 0;
                            color: #333333;
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }
}
</style>